<template>
    <span class="volume-outline-icon">
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
            />
            <template v-if="muted">
                <line x1="22" x2="16" y1="9" y2="15" />
                <line x1="16" x2="22" y1="9" y2="15" />
            </template>
            <template v-else>
                <path d="M16 9a5 5 0 0 1 0 6" />
                <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
            </template>
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconVolumeOutline',
    props: {
        stroke: {
            type: String,
            default: 'currentColor',
        },
        muted: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
/* See IconPlayOutline.vue for why the wrapper needs to be a flex container
   itself: a plain <span> as a flex/grid item doesn't center its own
   inline-level svg content vertically. */
.volume-outline-icon {
    display: inline-flex;
    align-items: center;
}
</style>
